/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */

/**
 * publish: rotated_in, pinned, reasserted. unpublish: rotated_out, reasserted, not_priced and in_auction (a live product that can no longer be sold goes offline and frees its slot). keep: still_selected, pool_too_small (the eligible pool is not larger than liveCount), pinned, adopted (published outside the schedule and now in its batch), schedule_ended (ended with onEnd keep: left published, no longer owned). skip: not_priced, in_auction, store_read_only, owned_elsewhere. release (unpublished, or already offline, and no longer owned): master_inactive, master_deleted, excluded, member_removed, store_removed, rule_no_longer_matches, store_product_removed, schedule_ended
 */
export type ScheduleRunItemReason = typeof ScheduleRunItemReason[keyof typeof ScheduleRunItemReason];


export const ScheduleRunItemReason = {
  rotated_in: 'rotated_in',
  rotated_out: 'rotated_out',
  pinned: 'pinned',
  still_selected: 'still_selected',
  pool_too_small: 'pool_too_small',
  reasserted: 'reasserted',
  adopted: 'adopted',
  not_priced: 'not_priced',
  in_auction: 'in_auction',
  store_read_only: 'store_read_only',
  owned_elsewhere: 'owned_elsewhere',
  master_inactive: 'master_inactive',
  master_deleted: 'master_deleted',
  excluded: 'excluded',
  member_removed: 'member_removed',
  store_removed: 'store_removed',
  rule_no_longer_matches: 'rule_no_longer_matches',
  store_product_removed: 'store_product_removed',
  schedule_ended: 'schedule_ended',
} as const;
